import React from "react";
import styled from "@emotion/styled";

import TextLink from "~/components/links/TextLink";

const CaptchaText = styled.div`
    font-size: 1.6rem;
    text-align: center;
    padding: 10px;
`;

const CaptchaLink = styled(TextLink)`
    @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
        font-size: 1.6rem;
    }
`;

const CaptchaTermsAndConditions = ({ marginTop }) => {
    return (
        <CaptchaText {...{ marginTop }}>
            This site is protected by{" "}
            <a external href="https://friendlycaptcha.com">
                Friendly Captcha
            </a>{" "}
            and its{" "}
            <CaptchaLink
                external
                to="https://friendlycaptcha.com/privacy/user-protection/"
            >
                Privacy Policy
            </CaptchaLink>{" "}
            and{" "}
            <CaptchaLink external to="https://friendlycaptcha.com/legal/terms">
                Terms of Use
            </CaptchaLink>{" "}
            apply.
        </CaptchaText>
    );
};

export default CaptchaTermsAndConditions;
